var scriptUrl = __webpack_require__.__SPARKY_MICRO_APP________________RNDlu988amrrnd________________WEBPACK_PUBLIC_URL_ENTRY_LOADER_JS__;
if (!scriptUrl && __webpack_require__.g.importScripts) scriptUrl = __webpack_require__.g.location + "";
var document = __webpack_require__.g.document;
if (!scriptUrl && document) {
	if (document.currentScript)
		scriptUrl = document.currentScript.src;
	if (!scriptUrl) {
		throw new Error("Automatic publicPath is not supported when document.currentScript is not available");
	}
}
if (!scriptUrl) throw new Error("Automatic publicPath is not supported in this browser");
scriptUrl = scriptUrl.replace(/[?#].*$/, "").replace(/\/[^\/]+$/, "/");
__webpack_require__.p = scriptUrl + "../";